import React from 'react';
import PropTypes from 'prop-types';

const FavoriteIcon = ({ color }) => {
  return (
    <svg
      version="1.1"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="26px"
      height="23.25px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>Favorite Career</title>
      <g id="Group_41" transform="translate(0 -52.915)">
        <g id="Path_38" transform="translate(0 52.915)">
          <path
            id="Path_13918"
            className="st0"
            d="M498.03,947.69L78.56,514.07c-106-103.79-107.78-273.86-3.99-379.86
           c50.51-51.58,119.65-80.66,191.84-80.68l0,0c88,0.08,170.41,43.17,220.69,115.39l10.81,15.38l10.77-15.38
           C593.46,47.15,760.9,17.16,882.67,101.94c13.71,9.55,26.5,20.35,38.21,32.27c103.98,105.85,102.47,275.94-3.38,379.92c0,0,0,0,0,0
           l0,0L498.03,947.69z"
          />
        </g>
      </g>
    </svg>
  );
};

export default FavoriteIcon;

FavoriteIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
